/**
 * Enum for ViewMode
 */
export enum ViewMode {
    UNKNOWN = 0,
    COMPACT = 1,
    EXPANDED = 2,
    BUTTONPOPUP = 3
}

/**
 * Handle options for break page view mode
 */
export enum ModeForBreakPage {
    GRID = 0,
    GRAPHIC = 1
}